import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { pickVersionName } from '@/lib/responsiveImages';

const DEVICES = [
  { id: 'iphone-se', name: 'Smartphone piccolo (iPhone SE)', w: 375, h: 667 },
  { id: 'iphone-15', name: 'Smartphone moderno (iPhone 15)', w: 393, h: 852 },
  { id: 'android', name: 'Android (Pixel 8)', w: 412, h: 915 },
  { id: 'tablet-v', name: 'Tablet verticale (iPad)', w: 768, h: 1024 },
  { id: 'tablet-h', name: 'Tablet orizzontale (iPad)', w: 1024, h: 768 },
  { id: 'laptop', name: 'Laptop', w: 1366, h: 768 },
  { id: 'desktop', name: 'Desktop', w: 1920, h: 1080 },
];

const VERSION_LABELS = { mobile: 'Mobile 1200px', tablet: 'Tablet 1600px', desktop: 'Desktop 2400px' };
const PREVIEW_WIDTH = 320;

// Simulates the real gallery rendering (object-contain, max 75% viewport height) per device.
export default function DevicePreview({ responsive, originalUrl }) {
  const [deviceId, setDeviceId] = useState('iphone-15');
  const device = DEVICES.find((d) => d.id === deviceId);
  const versionName = pickVersionName(device.w);
  const src = versionName === 'mobile'
    ? responsive?.mobile_override || responsive?.mobile?.url || originalUrl
    : responsive?.[versionName]?.url || originalUrl;
  const scale = Math.min(1, PREVIEW_WIDTH / device.w);

  return (
    <div className="space-y-3">
      <Select value={deviceId} onValueChange={setDeviceId}>
        <SelectTrigger className="w-full sm:w-72"><SelectValue /></SelectTrigger>
        <SelectContent>
          {DEVICES.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <p className="text-xs text-[#7a7a7a]">
        {device.name} — viewport {device.w}×{device.h}px — versione usata: <strong>{VERSION_LABELS[versionName]}</strong>
        {versionName === 'mobile' && responsive?.mobile_override ? ' (immagine alternativa mobile)' : ''}
      </p>
      <div className="overflow-hidden rounded border border-[#e5e5e5] bg-[#fafafa] p-3" style={{ height: device.h * scale + 24 }}>
        <div style={{ width: device.w, height: device.h, transform: `scale(${scale})`, transformOrigin: 'top left' }} className="border border-[#d5d5d5] bg-white shadow-sm">
          {/* Same rules as the public gallery: full width, object-contain, max 75% of viewport height */}
          <div className="flex h-full w-full items-center justify-center bg-white">
            <img src={src} alt="Anteprima dispositivo" className="w-auto max-w-full object-contain" style={{ maxHeight: device.h * 0.75 }} />
          </div>
        </div>
      </div>
    </div>
  );
}